<template>
  <div class="about">
    <h1>This is an about page</h1>
    <p>Today is {{ weekday }}</p>
    <button @click="findNextAvailableMonday">Next Monday</button>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      weekday: 'Monday'
    }
  },
  methods: {
    findNextAvailableMonday() {
      let d = new Date()
      d.setDate(d.getDate() + ((7 - d.getDay()) % 7 + 1) % 7)
      console.log(d)
      this.weekday = moment(d).add(3, 'week').format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
